import { get, post } from '../api';

const resolveCampaignBasePath = (channelType = 'email') =>
    channelType === 'whatsapp'
        ? 'marketing/whatsapp/campaign'
        : 'marketing/email/campaigns';

const tagsBasePath = (source = 'customer') =>
    `marketing/email/campaigns/${source}/segmentation-tags`;

const basePath = (source = 'customer', channelType = 'email') =>
    `${resolveCampaignBasePath(channelType)}/${source}/segmentation-tags`;

const findAll = async (source = 'customer', channelType = 'email') =>
    get({ type: 'user', service: tagsBasePath(source) });

const findByCampaignIdAndChannelType = async (campaignId, channelType) =>
    get({ type: 'user', service: `marketing/email/campaigns/${campaignId}/${channelType}/segmentation-config` });

const normalizeConfig = (config) => {
    if (!config || typeof config !== 'object') return { included: [] };
    const included = Array.isArray(config.included) ? config.included : [];
    return { included };
};

const countContacts = async (source = 'customer', segmentationConfig = { included: [] }, channelType = 'email') =>
    post({
        type: 'user',
        service: `${basePath(source, channelType)}/count`,
        data: normalizeConfig(segmentationConfig),
    });

export default {
    findAll,
    findByCampaignIdAndChannelType,
    countContacts,
};
